import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/taxonomy/base-url';
import type { JobTitle } from '@/models/taxonomy/job';

export const useJobTitlesSearch = (term: string) => {
  const result = useQuery<JobTitle[]>({
    queryKey: [clientKeys.useJobTitlesSearch, term],
    enabled: !!term,
    queryFn: async () => {
      const url = `${baseUrl}/job/titles/search?term=${term}`;
      return await falconClient.get(url);
    },
  });

  return { ...result, options: result.data || [] };
};
